<div class="login">

    <div class="login__wrapper">
        <div class="container-fluid container-fluid--rm-padding container-fluid--rm-inner-padding">
            <div class="row">
                <div class="col-xs-12">

                    <div class="login__col login__col--left">

                        <!-- Logo -->
                        <img class="login__logo logo-main" src="assets/img/logo.svg" alt="B2B Grupo Soledad Logo">

                        <div class="mt54 mb60 text-center">

							<h2 class="login__title login__title--lg">404</h2>
							<p class="login__text login__text--lg">{{ '404_txt' | translate }}</p>

                        </div>

                        <div class="login__link-action login__link-action--back text-center">
                            <a class="login__link-action-link" href="#" (click)="backToLogin($event)">
								<svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1 5.866l5.5 4.866" stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                {{ 'checkout_pay_back' | translate }}
                            </a>
                        </div>

                    </div>
				</div>

            </div>
        </div>
    </div>
</div>
